/* MELT NOIR — editorial interactions */
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Shade finder tabs
  function initShades(scope) {
    $$('[data-shades]', scope).forEach((root) => {
      const btns = $$('[data-shade]', root);
      btns.forEach((b) => b.addEventListener('click', () => {
        const i = b.dataset.shade;
        btns.forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', String(on)); });
        $$('[data-shade-panel]', root).forEach((p) => { p.hidden = p.dataset.shadePanel !== i; });
        $$('[data-shade-stage]', root).forEach((s) => s.classList.toggle('is-active', s.dataset.shadeStage === i));
        root.style.setProperty('--active-shade', getComputedStyle(b).getPropertyValue('--shade'));
      }));
      if (btns[0]) root.style.setProperty('--active-shade', getComputedStyle(btns[0]).getPropertyValue('--shade'));
    });
  }

  // Scroll statement: words light up as you scroll
  function initStatements(scope) {
    $$('[data-statement-text]', scope).forEach((el) => {
      if (el.dataset.split) return;
      el.dataset.split = '1';
      const walk = (node) => {
        Array.from(node.childNodes).forEach((n) => {
          if (n.nodeType === 3) {
            const frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach((w) => {
              if (!w.trim()) { frag.appendChild(document.createTextNode(w)); return; }
              const s = document.createElement('span'); s.className = 'w'; s.textContent = w; frag.appendChild(s);
            });
            n.replaceWith(frag);
          } else if (n.nodeType === 1) walk(n);
        });
      };
      walk(el);
      const words = $$('.w', el);
      if (reduce) { words.forEach((w) => w.classList.add('on')); return; }
      const update = () => {
        const r = el.getBoundingClientRect();
        const vh = window.innerHeight;
        const p = Math.min(Math.max((vh * 0.85 - r.top) / (r.height + vh * 0.35), 0), 1);
        const lit = Math.round(p * words.length);
        words.forEach((w, i) => w.classList.toggle('on', i < lit));
      };
      window.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      update();
    });
  }

  // Drag-to-scroll strips
  function initDrag(scope) {
    $$('[data-drag-scroll]', scope).forEach((el) => {
      let down = false, startX = 0, startL = 0, moved = false;
      el.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startL = el.scrollLeft; el.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        el.scrollLeft = startL - dx;
      });
      window.addEventListener('pointerup', () => { down = false; el.classList.remove('is-dragging'); });
      el.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  // Magnetic buttons
  function initMagnetic(scope) {
    if (!fine || reduce) return;
    $$('[data-magnetic]', scope).forEach((b) => {
      b.addEventListener('pointermove', (e) => {
        const r = b.getBoundingClientRect();
        b.style.translate = `${(e.clientX - r.left - r.width / 2) * 0.25}px ${(e.clientY - r.top - r.height / 2) * 0.35}px`;
      });
      b.addEventListener('pointerleave', () => { b.style.translate = ''; });
    });
  }

  function init(scope = document) { initShades(scope); initStatements(scope); initDrag(scope); initMagnetic(scope); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
